import {Box} from "@mui/material"
import useResponsive from "../../hooks/useResponsive"

export default function Main({children, sx, ...other}) {
    return (
        <Box
            component="main"
            sx={{height: "100%", backgroundColor: "black"}}
        >
            {children}
        </Box>
    )
}